import React, { useState } from "react";
import css from './NewsLetterSubscription.module.css'
import { PrimaryButtonInline } from "../Button/Button";
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { FormattedMessage, useIntl } from '../../util/reactIntl';
import { postMailerLite } from "../../util/api";
import * as log from "../../util/log";
import Spinner from "../IconSpinner/IconSpinner";

// Paper-plane send glyph, drawn inline (white) so it stays visible on the dark
// round submit button of the refreshed newsletter card.
const SendIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M2 12 L 22 2 L 14 22 L 11 13 L 2 12 Z" />
  </svg>
);

const NewsLetterSubscription = props => {
    const [email, setEmail] = useState("")
    const [loading, setLoading] = useState(false)
    const [error, setError] = useState(null)
    const [success, setSuccess] = useState(null)

    const { executeRecaptcha } = useGoogleReCaptcha();
    const intl = useIntl();

    const addToNewsLetter = async (e) => {
        e.preventDefault()
        if (!executeRecaptcha) {
            setError(intl.formatMessage({ id: 'NewsLetterSubscription.errorRecaptcha' }));
            return;
        }
        try {
            setLoading(true)
            setError(null)
            setSuccess(null)
            const recaptchaToken = await executeRecaptcha('newsletter');
            const response = await postMailerLite({ email, recaptchaToken, })
            if (response.success) {
                setSuccess(intl.formatMessage({ id: 'NewsLetterSubscription.success' }, { email }))
                setEmail("")
            } else {
                // The endpoint answers HTTP 200 with `success: false` and MailerLite's
                // own wording, which is written for developers ("Unauthenticated." when
                // the API key has expired, for example). Show our own sentence and keep
                // the raw reason in the logs.
                log.error(
                    new Error(response.message || 'MailerLite rejected the subscription'),
                    'newsletter-subscription-failed',
                    { email }
                );
                setError(intl.formatMessage({ id: 'NewsLetterSubscription.errorSubscribe' }))
            }
            setLoading(false)
        } catch (err) {
            setLoading(false)
            log.error(err, 'newsletter-subscription-failed', { email })
            setError(intl.formatMessage({ id: 'NewsLetterSubscription.errorServer' }))
        }
    }


    return <div className={css.newsletterWrapper}>
        <span className={css.subtitle}><FormattedMessage id="NewsLetterSubscription.pill" /></span>
        <h2 className={css.title}><FormattedMessage id="NewsLetterSubscription.title" /></h2>
        <p className={css.description}><FormattedMessage id="NewsLetterSubscription.description" /></p>
        <form className={css.formWrapper} onSubmit={addToNewsLetter}>
            <input className={css.emailInput} type="email" placeholder={intl.formatMessage({ id: 'NewsLetterSubscription.emailPlaceholder' })} aria-label={intl.formatMessage({ id: 'NewsLetterSubscription.emailAriaLabel' })} onChange={e => setEmail(e.target.value)} value={email} />
            <PrimaryButtonInline className={css.submitButton} type="submit" aria-label={intl.formatMessage({ id: 'NewsLetterSubscription.submitAriaLabel' })}>
                {loading ? <Spinner className={css.spinner} /> : <SendIcon />}
            </PrimaryButtonInline>
        </form>
        {error && <span className={css.error}>{error}</span>}
        {success && <span className={css.success}>{success}</span>}
    </div>
}

export default NewsLetterSubscription